export default {"src":"https://images-cdn.curipod.com/d-5c7be32e/_next/static/media/loaderstars.62e39e18.svg","height":669,"width":679};